export default __webpack_public_path__ + "static/media/image19.79030603.png";